<priva-form [hasTitle]="true" [hasIntro]="(isNfcReaderAvailable$ | async) === true" class="signin-form">
    <ng-container data-title>
        <priva-title [title]="title()" size="lg" />
    </ng-container>

    <ng-container data-intro
        ><span>{{ 'LOGIN.INFO.TOUCH_DEVICE_TO_NFC_TAG' | translate }}</span></ng-container
    >

    <priva-form-section class="margin-top-2" [hasTitle]="false">
        <priva-form-group [hasLabel]="true" [hasHelp]="false" [formGroup]="formGroup">
            <ng-container data-label>{{ 'GENERAL.TITLE.EMPLOYEE_NUMBER' | translate }}</ng-container>
            <div class="input-with-btn">
                <input
                    #employeeNrInput
                    type="number"
                    priva-input
                    pattern="[0-9]*"
                    formControlName="employeeNumber"
                    data-test="input-employee-nr"
                    tabindex="1"
                    (keydown.enter)="tryCompleteEmployeeNrInput()"
                    [readonly]="isManualInputForbidden$ | async"
                    (click)="scanBarcodeIfManualInputForbidden()"
                />
                <button
                    priva-button
                    #scanButton
                    (click)="scan()"
                    type="button"
                    data-test="scan-btn"
                    [iconClass]="scanQrBtnIconClass"
                    iconState="Left"
                    class="input-with-btn__btn"
                    [class.hidden-btn]="(isScanBarcodeEnabled$ | async) === false"
                    tabindex="2"
                >
                    <p class="input-with-btn__label">{{ 'GENERAL.ACTION.SCAN' | translate }}</p>
                </button>
            </div>
            @if (employeeControl.touched && employeeControl.errors) {
                <div class="form-control-validation" data-test="employee-nr-validation-error">
                    <div class="form-control-validation__item">
                        <span class="form-control-validation__item-icon fas fa-exclamation-circle"></span>
                        <span class="form-control-validation__item-message">
                            {{
                                (employeeControl.errors?.['required']
                                    ? 'LOGIN.ERROR.EMPLOYEE_NUMBER_IS_REQUIRED'
                                    : 'LOGIN.ERROR.WRONG_EMPLOYEE_NUMBER'
                                ) | translate
                            }}
                        </span>
                    </div>
                </div>
            }
        </priva-form-group>

        <priva-form-group [hasLabel]="true" [hasHelp]="false" [formGroup]="formGroup">
            <ng-container data-label>{{ 'LOGIN.TITLE.PIN' | translate }}</ng-container>
            <div class="input-with-btn">
                <input
                    #pinInput
                    type="text"
                    inputmode="numeric"
                    class="password-field"
                    pattern="[0-9]*"
                    priva-input
                    formControlName="pin"
                    data-test="input-employee-pin"
                    (keydown.enter)="authenticateIfPossible()"
                    tabindex="3"
                />

                <button
                    priva-button
                    (click)="authenticate()"
                    importance="Primary"
                    [isDisabled]="!canAuthenticate()"
                    type="button"
                    data-test="auth-confirm-btn"
                    class="input-with-btn__btn"
                    tabindex="4"
                >
                    {{ 'GENERAL.ACTION.CONFIRM' | translate }}
                </button>
            </div>

            @if ((pinControl.touched || pinControl.dirty) && pinControl.errors) {
                <div class="form-control-validation" data-test="pin-validation-error">
                    <div class="form-control-validation__item">
                        <span class="form-control-validation__item-icon fas fa-exclamation-circle"></span>
                        <span class="form-control-validation__item-message">
                            {{
                                (pinControl.errors?.['pattern']
                                    ? 'LOGIN.ERROR.PIN_SHOULD_CONTAIN_DIGITS_ONLY'
                                    : pinControl.errors?.['required']
                                      ? 'LOGIN.ERROR.PIN_REQUIRED'
                                      : 'LOGIN.ERROR.WRONG_PIN_ENTERED'
                                ) | translate
                            }}
                        </span>
                    </div>
                </div>
            }

            @if (formGroup.errors?.['authentication']; as error) {
                <div class="form-control-validation" data-test="credentials-validation-error">
                    <div class="form-control-validation__item">
                        <span class="form-control-validation__item-icon fas fa-exclamation-circle"></span>
                        @if (error === 'invalid-credentials') {
                            <span class="form-control-validation__item-message" data-test="error-wrong-pin">
                                {{ 'LOGIN.ERROR.EMPLOYEE_OR_PIN_INCORRECT' | translate }}
                            </span>
                        }
                        @if (error === 'technical-error') {
                            <span class="form-control-validation__item-message">
                                {{ 'LOGIN.ERROR.TECHNICAL_PROBLEM' | translate }}
                            </span>
                        }
                    </div>
                </div>
            }
            @if (formGroup.errors?.['authorisation']) {
                <div class="form-control-validation" data-test="authorization-error">
                    <div class="form-control-validation__item">
                        <span class="form-control-validation__item-icon fas fa-exclamation-circle"></span>
                        <span class="form-control-validation__item-message">
                            {{
                                formGroup.errors?.['authorisation']
                                    | translate: { requiredRoles: formGroup.errors?.['requiredRoles'] }
                            }}
                        </span>
                    </div>
                </div>
            }
        </priva-form-group>
    </priva-form-section>

    <div>
        @if (authenticating$ | async) {
            <priva-spinner />
        }
    </div>

    @if (isNfcReaderAvailable$ | async) {
        <app-scan-nfc-controller
            [hideReaderMalfunctionError]="(hideReaderMalfunctionError$ | async) === true"
            [allowedCodeTypes]="['employee']"
            (readEvent)="onNfcRead($event)"
            [showButton]="false"
        />
    }
</priva-form>
